// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__CJobU","error":"style_error__IO7sw","formItem":"style_formItem__cxorY"};